<template>
  <v-card v-if="!ignoreNoActiveFilter && noActiveFilter" outlined>
    <v-card-text>
      <div class="text--primary">
        <p>Es sind keine Filter aktiv, sodass möglicherweise eine große Anzahl an Datensätzen geladen wird.</p>
        <p>Passen Sie den Zeitraum oder die Auswahl der Mitarbeiter bzw. Projekte an oder klicken Sie auf "Trotzdem Laden", um die Daten anzuzeigen.</p>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-btn text color="red" @click="ignoreNoActiveFilter=true">
        Trotzdem Laden
      </v-btn>
    </v-card-actions>
  </v-card>

  <div v-else>
    <Alert />
    <v-expand-transition>
      <Pivot2
        v-show="!showDetails"
        class="mb-2"
        :collapseable.sync="pivotCollapesable"
        :collapsed.sync="pivotCollapsed"
        @selected="pivotSelected"
      />
    </v-expand-transition>
    <v-expand-transition>
      <DetailsTable2
        v-show="showDetails"
        :filters="filterParams"
        @close="closeDetails"
      />
    </v-expand-transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import Alert from '../Alert'
import Pivot2 from './Pivot2'
import DetailsTable2 from './DetailsTable2'

export default {
  metaInfo: {
    title: "Auswertung",
  },
  components: {
    Pivot2,
    DetailsTable2,
    Alert,
  },
  data () {
    return {
      pivotCollapesable: false,
      pivotCollapsed: false,
      selectedProjectId: null,
      selectedEmployeeId: null,
      showDetails: false,
      profileOptions: [
        {
          'name': 'Detailansicht',
          'icon': 'browser',
          'options': [
            ['show_project_color', 'Projekt Farbe'],
            ['format_date_with_day', 'Zeige Datum mit Tag'],
            ['format_hour_as_number', 'Zeige Dauer als Zahl'],
            ['show_operation', 'Zeige Aufgabe']
          ]
        }
      ],
      ignoreNoActiveFilter: false
    }
  },
  computed: {
    filterParams () {
      const r = {
        taskday__gte: this.selectedPeriod.start.format('YYYY-MM-DD'),
        taskday__lte: this.selectedPeriod.end.format('YYYY-MM-DD'),
      }
      if (this.selectedTenant !== null) {
        r.tenant = this.selectedTenant
      }

      if (this.selectedProjectId !== null) {
        r.project = this.selectedProjectId
      } else {
        r.project__in = this.selectedProjects.map(i => i.id)
      }

      if (this.selectedEmployeeId !== null) {
        r.employee = this.selectedEmployeeId
      } else {
        r.employee__in = this.selectedEmployees.map(i => i.id)
      }
      return r
    },
    noActiveFilter () {
      return (!this.selectedPeriod.selection || this.selectedPeriod.selection === 'unfiltered')
              && this.selectedEmployees.length === 0
              && this.selectedProjects.length === 0
    },
    ...mapGetters([
      'selectedEmployees',
      'selectedPeriod',
      'selectedProjects',
      'selectedTenant',
      'profile',
    ])
  },
  methods: {
    pivotSelected ({projectId, employeeId}) {
      this.selectedProjectId = projectId
      this.selectedEmployeeId = employeeId
      this.showDetails = true
      if (this.pivotCollapesable === false) {
        // only touch this, if it's a new option
        this.pivotCollapsed = true
      }
      this.pivotCollapesable = true
    },
    closeDetails () {
      this.showDetails = false
      this.pivotCollapesable = false
      this.pivotCollapsed = false
    },
  },
  created () {
    if (this.profile.evaluation_view === 'detail') {
      this.pivotSelected({projectId: null, employeeId: null})
    }
    else if(this.profile.evaluation_view === undefined){
      let unwatch = this.$watch('profile', () => {
        if (this.profile.evaluation_view === 'detail') {
	        this.pivotSelected({projectId: null, employeeId: null})
          unwatch()
        }
      })
    }
  }
}

</script>

<style lang="scss" scoped>
  .profile {
    @media screen and (max-width: 400px) {
      display: none;
    }
  }
  .table-wrapper {
    flex: 1 1 auto;
    overflow: auto;
  }
</style>
